// plugins/route-preload.client.ts
import { preloadRouteComponents } from '#app'

export default defineNuxtPlugin(() => {
  const router = useRouter()

  // 所有预渲染的页面，可能每个项目使用的房间不一样，预渲染房间看项目
  // , '/aboutme'
  const allRoutes = ['/', '/home', '/chat']

  // 已经 preload 过的（避免重复）
  const loaded = new Set<string>()

  function startPreload() {
    const currentPath = router.currentRoute.value.path

    // 过滤掉当前页面 + 已加载页面
    const targets = allRoutes.filter((r) => r !== currentPath && !loaded.has(r))

    if (!targets.length) return

    let i = 0

    const loadNext = () => {
      if (i >= targets.length) return

      const route = targets[i++]
      preloadRouteComponents(route)
      loaded.add(route)

      requestIdleCallback(loadNext)
    }

    requestIdleCallback(loadNext)
  }

  // 首屏加载完再执行
  window.addEventListener('load', () => {
    setTimeout(startPreload, 1200)
  })

  // 👇 关键优化：路由切换后，再补充 preload
  router.afterEach(() => {
    setTimeout(() => {
      startPreload()
    }, 800)
  })
})
